import type { StartSessionResponse } from '@/practice/api';
import type { MediaSessionCredentials } from './types';

export function getMediaSessionCredentials(
  response: StartSessionResponse,
): MediaSessionCredentials {
  if (response.media === undefined) {
    return {
      provider: 'daily',
      sessionId: response.sessionId,
      endpointId: response.room.id,
      url: response.room.url,
      roomName: response.room.name,
      token: response.token,
      tokenExpiresAt: null,
    };
  }

  return {
    provider: response.media.provider,
    sessionId: response.sessionId,
    endpointId: response.media.endpointId,
    url: response.media.url,
    roomName: response.media.roomName,
    token: response.media.token,
    tokenExpiresAt: response.media.tokenExpiresAt,
  };
}
